import { gql } from '@apollo/client/core';

export const SUBMIT_COURSE_REGISTRATION = gql`
  mutation SubmitCourseRegistration($input: courseRegistrationInput!) {
    submitCourseRegistration(input: $input) {
      id
      academic_session
      semester
      registration_level
      coursesRegistered {
        programme_module_id
        module_name
        module_sequence
        id
        course_status
        course { id course_code course_title unit }
      }
    }
  }
`;

export const RESUBMIT_COURSE_REGISTRATION = gql`
  mutation ResubmitCourseRegistration($input: courseRegistrationInput!) {
    resubmitCourseRegistration(input: $input) {
      id
      coursesRegistered {
        programme_module_id
        module_name
        module_sequence
        id
        course_status
        course { id course_code course_title unit }
      }
    }
  }
`;
